(function () {

    'use strict';

    angular.module('map')
        .service('mapConfigService', mapConfigService);

    mapConfigService.$inject = ['arcgisBase', 'serviceBase'];
    function mapConfigService(arcgisBase, serviceBase) {
        return {
            mapServerTiledURL: '//www.geoportal.lt/arcgis/rest/services/geoportal_public/background_Lietuva_3346/MapServer',
            mapOrthoLayerCacheURL: '//www.geoportal.lt/arcgis/rest/services/geoportal_public/background_Lietuva-Misrus-3346/MapServer',
            mapServerTiledFallbackURL: arcgisBase + '/EismoInfo_cache_150224/MapServer',
            mapOrthoLayerCacheFallbackURL: arcgisBase + '/ORT_MISRUS/MapServer',
            googleStreetViewURL: 'https://www.google.lt/maps/?cbll=',
            geometryServiceURL: arcgisBase + '/Utilities/Geometry/GeometryServer',
            kpoGeometryURL: serviceBase + '/road-monitoring/resource/geometry',

            mapIconConfig: {
                DNAU: {
                    V: [255, 0, 0],     //Veluojantis
                    A: [255, 137, 137], //Artejantis
                    N: [146, 208, 80]  //Normalus
                },
                DISP: {
                    V: [191, 191, 191],
                    A: [191, 191, 191],
                    N: [191, 191, 191]
                },
                DPER: {
                    V: [255, 0, 0],
                    A: [255, 137, 137],
                    N: [255, 217, 102]
                },
                DATM: {
                    V: [128, 128, 128],
                    A: [128, 128, 128],
                    N: [128, 128, 128]
                },
                DSPR: {
                    S: [43, 38, 216] // Sprendžiama
                },
                DLAP: {
                  V: [138, 34, 215],
                  A: [138, 34, 215],
                  N: [138, 34, 215]
                }
            }
        }
    }
})();
